import Button from '@components/button';
import Popup from '@components/popup';
import { observer } from 'mobx-react-lite';

import { addInvoice } from 'constants/pages';
import { useStore } from 'hooks/useStore';
import { interpolate } from 'utils/string/format';

const Footer = () => {
  const {
    app: { i18n, env },
    savedFilters: { popup, closePopup },
  } = useStore();
  if (!popup) return null;

  const primaryButtonText =
    popup?.validationResult?.isUserBalanceTooLow && popup.hasSubscription.value
      ? i18n.filterPopup.saveAndTopBalance
      : i18n.filterPopup.save;

  const handleSave = () => {
    if (popup?.validationResult?.isUserBalanceTooLow && popup.hasSubscription.value) {
      window.open(interpolate(addInvoice, { env }), '_blank')?.focus();
    }
    popup.saveFilter();
  };

  const handleUnsubscribe = () => {
    popup.unsubscribe();
    closePopup();
  };

  return (
    <>
      <Popup.ActionWrapper type="main">
        <Button fullWidth disabled={popup.isSaveDisabled} loading={popup.isSaving} theme="primary" onClick={handleSave}>
          {primaryButtonText}
        </Button>
      </Popup.ActionWrapper>

      <Popup.ActionWrapper type="cancel">
        <a className="glz-link glz-is-medium glz-is-primary" onClick={closePopup}>
          {i18n.filterPopup.cancel}
        </a>
      </Popup.ActionWrapper>

      {popup.validationResult?.resultFilter?.subscription && (
        <Popup.ActionWrapper type="second">
          <Button fullWidth onClick={handleUnsubscribe}>
            {i18n.filterPopup.unsubscribe}
          </Button>
        </Popup.ActionWrapper>
      )}
    </>
  );
};

const connected = observer(Footer);

export { connected as Footer };
